export enum WebSocketDataTypes {
  indicators = 1,
  geo = 2,
  tacho = 4,
  speedLimit = 6,
}
